import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './header.actions';

export interface HeaderState {
  favoriteCount: number;
  inboxCount: number;
  loading: boolean;
  loaded: boolean;
}

export const initialState: HeaderState = <HeaderState>{
  favoriteCount: 0,
  inboxCount: 0,
  loading: false,
  loaded: false,
};

const _headerReducer = createReducer(
  initialState,
  on(fromActions.loadCount, (state: HeaderState) => ({ ...state, loading: true, loaded: false })),
  on(fromActions.loadCountSuccess, (state, action) => {
    const { favoriteCount, inboxCount } = action;
    return { ...state, favoriteCount, inboxCount, loading: false, loaded: true };
  }),
  on(fromActions.loadCountFail, (state: HeaderState) => (
    { ...state, loading: false, loaded: false }
  )),
);

export function headerReducer(state: HeaderState, action: Action) {
  return _headerReducer(state, action);
}

export const mainHeaderKey = 'mainHeader';
